import { moderationDashModuleQuery, useModule } from 'system/structure-modules';

export default function ModerationDashboardChannelsScreen() {
    const { ChannelSettingsPage } = useModule(moderationDashModuleQuery);
    return <ChannelSettingsPage />;
}
